import BrowserModal from './BrowserModal';

export default BrowserModal;
